import * as Msdyn365 from '@msdyn365-commerce/core';
import { ensureAuthenticated } from '../../utilities/is-authenticated';
import { trackedAction } from '../../utilities/track-execution-time';
import { escapeODataStringLiteral } from '../../utilities/odata';

/**
 * GetEaspDocumentDownload Input Action
 */
export class GetEaspDocumentDownloadInput implements Msdyn365.IActionInput {
    public documentId: string;
    public downstreamSystem: string;

    constructor(documentId: string, downstreamSystem: string) {
        this.documentId = documentId;
        this.downstreamSystem = downstreamSystem;
    }

    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GetEaspDocumentDownload-${this.documentId}-${this.downstreamSystem}`;
    public getCacheObjectType = () => 'GetEaspDocumentDownload';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetEaspDocumentDownloadData {
    '@odata.context'?: string;
    FileName: string;
    Length: string;
    Type: string;
    Value: string;
    Content: string;
    RecordCreatedDate: Date;
    ExtensionProperties: unknown[];
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetEaspDocumentDownloadInput('', '');
};

async function action(input: GetEaspDocumentDownloadInput, ctx: Msdyn365.IActionContext): Promise<IGetEaspDocumentDownloadData> {
    ensureAuthenticated(ctx);
    let getDocumentDownloadData: IGetEaspDocumentDownloadData = {} as IGetEaspDocumentDownloadData;

    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/Document/Download(documentId='${escapeODataStringLiteral(
            input.documentId
        )}',downstreamSystem='${escapeODataStringLiteral(input.downstreamSystem)}')`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    )
        .then(res => {
            getDocumentDownloadData = res?.data as IGetEaspDocumentDownloadData;
        })
        .catch(error => {
            return { error: { errorCode: error.response.status, errorText: error.response.statusText } };
        });
    return getDocumentDownloadData;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetEaspDocumentDownloadData>>((input, ctx) => trackedAction(action, input, ctx, 'GetEaspDocumentDownload')),
    id: 'GetEaspDocumentDownload',
    input: createInput
});
